export const SET_DELIVERY_SETTINGS_CART_SETTINGS = 'SET_DELIVERY_SETTINGS_CART_SETTINGS'
export const UPDATE_DELIVERY_SETTINGS_CART_SETTING = 'UPDATE_DELIVERY_SETTINGS_CART_SETTING'
export const SET_DELIVERY_CHANGE_SETTINGS = 'SET_DELIVERY_CHANGE_SETTINGS'
export const UPDATE_DELIVERY_CHANGE_SETTING = 'UPDATE_DELIVERY_CHANGE_SETTING'
export const SET_DELIVERY_SETTINGS_BEEPER_CONFIGS = 'SET_DELIVERY_SETTINGS_BEEPER_CONFIGS'
